export interface ComicCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface Comic {
  slug: string;
  title: string;
  altTitle: string;
  author: string;
  artist: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: string;
  rating: number;
  views: number;
  favorites: number;
  tags: string[];
  totalChapters: number;
  latestChapter: string;
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export interface ComicChapter {
  number: number;
  title: string;
  updatedAt: string;
  images: string[];
}

export interface FAQ {
  question: string;
  answer: string;
}

export interface Review {
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

const COMIC_IMG_A1 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%20with%20clean%20lines%20and%20soft%20warm%20coloring%2C%20vertical%20scroll%20format%2C%20dramatic%20storytelling%20scene%2C%20manhwa%20aesthetic%2C%20warm%20lighting&width=800&height=1200&seq=comic-c01-p01&orientation=portrait';
const COMIC_IMG_A2 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20scene%20with%20characters%20in%20traditional%20clothing%2C%20soft%20emotional%20expressions%2C%20warm%20color%20palette%2C%20detailed%20background%2C%20webtoon%20style&width=800&height=1200&seq=comic-c01-p02&orientation=portrait';
const COMIC_IMG_A3 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dramatic%20moment%20with%20characters%20facing%20each%20other%2C%20emotional%20atmosphere%2C%20flower%20petals%2C%20soft%20focus%2C%20webtoon%20illustration%20style&width=800&height=1200&seq=comic-c01-p03&orientation=portrait';

const COMIC_IMG_B1 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20scene%20with%20warrior%20holding%20sword%2C%20dynamic%20movement%2C%20energy%20effects%2C%20epic%20fantasy%20battle%20atmosphere%2C%20warm%20golden%20lighting&width=800&height=1200&seq=comic-c02-p01&orientation=portrait';
const COMIC_IMG_B2 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20training%20scene%20in%20mountain%20setting%2C%20character%20practicing%20sword%20techniques%2C%20mist%20and%20sunlight%2C%20webtoon%20style&width=800&height=1200&seq=comic-c02-p02&orientation=portrait';
const COMIC_IMG_B3 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20climactic%20showdown%20scene%20with%20two%20warriors%2C%20intense%20staring%2C%20dramatic%20lighting%2C%20stormy%20sky%2C%20epic%20webtoon%20illustration&width=800&height=1200&seq=comic-c02-p03&orientation=portrait';

const COMIC_IMG_C1 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20hallway%20scene%20with%20students%20in%20uniforms%2C%20magical%20sparks%2C%20warm%20candlelight%2C%20fantasy%20webtoon%20style&width=800&height=1200&seq=comic-c03-p01&orientation=portrait';
const COMIC_IMG_C2 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20classroom%20scene%20with%20teacher%20demonstrating%20spell%2C%20colorful%20magic%20effects%2C%20enchanted%20atmosphere%2C%20webtoon%20illustration&width=800&height=1200&seq=comic-c03-p02&orientation=portrait';
const COMIC_IMG_C3 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20duel%20between%20students%2C%20energy%20blasts%2C%20excited%20crowd%2C%20arena%20setting%2C%20dramatic%20webtoon%20art%20style&width=800&height=1200&seq=comic-c03-p03&orientation=portrait';

const COMIC_IMG_D1 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20modern%20office%20scene%20with%20characters%20at%20desks%2C%20warm%20afternoon%20lighting%2C%20professional%20setting%2C%20romantic%20webtoon%20style&width=800&height=1200&seq=comic-c04-p01&orientation=portrait';
const COMIC_IMG_D2 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cafe%20scene%20with%20two%20characters%20sharing%20coffee%2C%20intimate%20conversation%2C%20city%20view%20through%20window%2C%20webtoon%20illustration&width=800&height=1200&seq=comic-c04-p02&orientation=portrait';
const COMIC_IMG_D3 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20rooftop%20night%20scene%20with%20city%20lights%2C%20romantic%20confession%20moment%2C%20starry%20sky%2C%20emotional%20webtoon%20art&width=800&height=1200&seq=comic-c04-p03&orientation=portrait';

const COMIC_IMG_E1 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20detective%20investigating%20crime%20scene%2C%20noir%20atmosphere%2C%20rainy%20alley%2C%20dark%20coat%2C%20mysterious%20webtoon%20style&width=800&height=1200&seq=comic-c05-p01&orientation=portrait';
const COMIC_IMG_E2 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20detective%20examining%20evidence%20in%20dim%20office%2C%20clues%20on%20desk%2C%20tense%20atmosphere%2C%20suspense%20webtoon%20illustration&width=800&height=1200&seq=comic-c05-p02&orientation=portrait';
const COMIC_IMG_E3 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20confrontation%20scene%20between%20detective%20and%20suspect%2C%20dramatic%20shadows%2C%20interrogation%20room%2C%20thriller%20webtoon%20art&width=800&height=1200&seq=comic-c05-p03&orientation=portrait';

const COMIC_IMG_F1 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20high%20school%20classroom%20scene%2C%20students%20chatting%2C%20spring%20sunlight%2C%20youthful%20atmosphere%2C%20slice%20of%20life%20webtoon%20style&width=800&height=1200&seq=comic-c06-p01&orientation=portrait';
const COMIC_IMG_F2 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20rooftop%20scene%20with%20friends%20eating%20lunch%2C%20blue%20sky%2C%20cheerful%20mood%2C%20youth%20webtoon%20illustration&width=800&height=1200&seq=comic-c06-p02&orientation=portrait';
const COMIC_IMG_F3 = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20graduation%20ceremony%20scene%2C%20students%20in%20gowns%2C%20emotional%20farewell%2C%20cherry%20blossoms%2C%20nostalgic%20webtoon%20art&width=800&height=1200&seq=comic-c06-p03&orientation=portrait';

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', description: '浏览所有韩国漫画', icon: 'ri-grid-line' },
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的爱情故事', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', description: '充满想象力的奇幻世界', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', description: '热血激情的动作漫画', icon: 'ri-sword-line' },
  { slug: 'comedy', name: '搞笑', description: '轻松幽默的搞笑漫画', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', description: '引人入胜的剧情漫画', icon: 'ri-film-line' },
  { slug: 'thriller', name: '悬疑', description: '扣人心弦的悬疑故事', icon: 'ri-search-eye-line' },
  { slug: 'daily', name: '日常', description: '温暖治愈的日常故事', icon: 'ri-sun-line' },
  { slug: 'school', name: '校园', description: '青春洋溢的校园生活', icon: 'ri-building-2-line' },
  { slug: 'historical', name: '古风', description: '唯美动人的古风漫画', icon: 'ri-ancient-gate-line' },
];

export const comics: Comic[] = [
  {
    slug: 'my-beloved-empress',
    title: '我的爱妃',
    altTitle: 'My Beloved Empress',
    author: '金秀贤',
    artist: '李知恩',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20featuring%20beautiful%20elegant%20female%20character%20in%20traditional%20hanbok%20dress%2C%20soft%20warm%20pink%20and%20gold%20tones%2C%20flower%20petals%20falling%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20vertical%20poster%20design%2C%20light%20cream%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一朝穿越成为帝国皇后，她本以为这是一场华丽的梦。然而面对冷酷无情的皇帝和虎视眈眈的后宫嫔妃，她能否在这深宫之中找到属于自己的幸福？一段跨越时空的浪漫爱情故事就此展开。',
    status: '连载中',
    rating: 4.8,
    views: 12500000,
    favorites: 890000,
    tags: ['穿越', '宫廷', '爱情', '逆袭'],
    totalChapters: 128,
    latestChapter: '第128话 - 命运的转折',
    updatedAt: '2026-08-04',
    chapters: [
      { number: 1, title: '穿越异世', updatedAt: '2025-03-15', images: [COMIC_IMG_A1, COMIC_IMG_A2, COMIC_IMG_A3, COMIC_IMG_B1, COMIC_IMG_B2] },
      { number: 2, title: '初入皇宫', updatedAt: '2025-03-22', images: [COMIC_IMG_B1, COMIC_IMG_B2, COMIC_IMG_B3, COMIC_IMG_C1] },
      { number: 3, title: '皇帝的目光', updatedAt: '2025-03-29', images: [COMIC_IMG_C1, COMIC_IMG_C2, COMIC_IMG_C3, COMIC_IMG_D1, COMIC_IMG_D2] },
    ],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'sword-of-destiny',
    title: '天命之剑',
    altTitle: 'Sword of Destiny',
    author: '朴志训',
    artist: '崔珉豪',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%20featuring%20powerful%20male%20warrior%20holding%20glowing%20sword%2C%20dynamic%20pose%2C%20dark%20dramatic%20background%20with%20energy%20effects%2C%20warm%20golden%20and%20amber%20accents%2C%20epic%20fantasy%20style%2C%20vertical%20poster%20design&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '少年林天背负着天命之剑的秘密，在乱世之中踏上武道巅峰之路。各路势力蠢蠢欲动，一场关乎天下命运的浩劫即将降临。他能否守护自己想要保护的一切？',
    status: '连载中',
    rating: 4.7,
    views: 9800000,
    favorites: 720000,
    tags: ['武侠', '热血', '奇幻', '成长'],
    totalChapters: 96,
    latestChapter: '第96话 - 剑指苍穹',
    updatedAt: '2026-08-03',
    chapters: [
      { number: 1, title: '天命觉醒', updatedAt: '2025-06-01', images: [COMIC_IMG_B1, COMIC_IMG_B2, COMIC_IMG_B3, COMIC_IMG_A1] },
      { number: 2, title: '初入江湖', updatedAt: '2025-06-08', images: [COMIC_IMG_B3, COMIC_IMG_A1, COMIC_IMG_A2, COMIC_IMG_C2] },
      { number: 3, title: '剑道传承', updatedAt: '2025-06-15', images: [COMIC_IMG_C1, COMIC_IMG_C3, COMIC_IMG_B2, COMIC_IMG_A3] },
    ],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'magic-academy-life',
    title: '魔法学院日常',
    altTitle: 'Magic Academy Life',
    author: '郑秀晶',
    artist: '金泰亨',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%20featuring%20young%20students%20in%20magic%20academy%20uniforms%20casting%20spells%2C%20vibrant%20magical%20effects%2C%20warm%20lighting%20in%20grand%20castle%20hall%2C%20whimsical%20and%20enchanting%20atmosphere%2C%20vertical%20poster%20design&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '普通少女苏菲意外收到魔法学院的录取通知书，从此开启了充满惊喜与冒险的魔法校园生活。在这里，她结识了一群可爱的朋友，也遇到了许多不可思议的挑战。',
    status: '连载中',
    rating: 4.6,
    views: 8600000,
    favorites: 650000,
    tags: ['魔法', '校园', '友情', '冒险'],
    totalChapters: 85,
    latestChapter: '第85话 - 魔法大赛',
    updatedAt: '2026-08-02',
    chapters: [
      { number: 1, title: '神秘的录取通知书', updatedAt: '2025-07-10', images: [COMIC_IMG_C1, COMIC_IMG_C2, COMIC_IMG_C3, COMIC_IMG_D1] },
      { number: 2, title: '初入魔法学院', updatedAt: '2025-07-17', images: [COMIC_IMG_C3, COMIC_IMG_A1, COMIC_IMG_B2, COMIC_IMG_D2] },
      { number: 3, title: '第一次魔法课', updatedAt: '2025-07-24', images: [COMIC_IMG_B1, COMIC_IMG_C2, COMIC_IMG_A3, COMIC_IMG_D3] },
    ],
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    slug: 'office-romance-secret',
    title: '办公室的秘密',
    altTitle: 'Office Romance Secret',
    author: '李敏镐',
    artist: '孙艺珍',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20featuring%20stylish%20office%20workers%20in%20modern%20city%20setting%2C%20two%20characters%20sharing%20intimate%20glance%2C%20professional%20attire%2C%20warm%20coffee%20shop%20background%2C%20soft%20romantic%20atmosphere%2C%20clean%20illustration%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '在同一家公司工作的两人，一个是冷面上司，一个是元气下属。白天是严肃的职场关系，晚上却有着不为人知的甜蜜秘密。这段办公室恋情能否经得起考验？',
    status: '连载中',
    rating: 4.5,
    views: 7500000,
    favorites: 580000,
    tags: ['职场', '恋爱', '甜宠', '都市'],
    totalChapters: 72,
    latestChapter: '第72话 - 意外的告白',
    updatedAt: '2026-08-01',
    chapters: [
      { number: 1, title: '入职第一天', updatedAt: '2025-08-01', images: [COMIC_IMG_D1, COMIC_IMG_D2, COMIC_IMG_D3, COMIC_IMG_A1] },
      { number: 2, title: '意外的加班', updatedAt: '2025-08-08', images: [COMIC_IMG_D2, COMIC_IMG_A2, COMIC_IMG_B1, COMIC_IMG_C2] },
      { number: 3, title: '咖啡店的偶遇', updatedAt: '2025-08-15', images: [COMIC_IMG_D3, COMIC_IMG_B2, COMIC_IMG_C1, COMIC_IMG_A3] },
    ],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'mystery-detective-kim',
    title: '侦探金先生',
    altTitle: 'Detective Kim',
    author: '张东健',
    artist: '李秉宪',
    category: '悬疑',
    categorySlug: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%20featuring%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alleyway%2C%20noir%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20suspenseful%20feeling%2C%20professional%20comic%20illustration%2C%20vertical%20poster%20design&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '天才侦探金宇成破获过无数离奇案件，但这一次的案件却让他陷入了前所未有的困境。连环杀人案背后隐藏着怎样的惊天秘密？真相远比想象中更加残酷。',
    status: '已完结',
    rating: 4.9,
    views: 11200000,
    favorites: 810000,
    tags: ['推理', '悬疑', '犯罪', '智斗'],
    totalChapters: 64,
    latestChapter: '第64话 - 真相（完结）',
    updatedAt: '2026-07-15',
    chapters: [
      { number: 1, title: '第一起案件', updatedAt: '2025-09-01', images: [COMIC_IMG_E1, COMIC_IMG_E2, COMIC_IMG_E3, COMIC_IMG_A1] },
      { number: 2, title: '蛛丝马迹', updatedAt: '2025-09-08', images: [COMIC_IMG_E2, COMIC_IMG_B1, COMIC_IMG_C2, COMIC_IMG_D1] },
      { number: 3, title: '关键线索', updatedAt: '2025-09-15', images: [COMIC_IMG_E3, COMIC_IMG_C1, COMIC_IMG_A2, COMIC_IMG_B3] },
    ],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'high-school-days',
    title: '那年高中',
    altTitle: 'High School Days',
    author: '金多美',
    artist: '朴宝剑',
    category: '校园',
    categorySlug: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%20art%20featuring%20high%20school%20students%20in%20uniforms%20walking%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20youthful%20and%20nostalgic%20feeling%2C%20warm%20sunlight%2C%20clean%20illustration%20style%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '平凡的高中生活因为一个转学生的到来而彻底改变。友情、梦想、初恋，青春最美好的时光里发生的故事，每一页都充满了温暖与感动。',
    status: '已完结',
    rating: 4.7,
    views: 6900000,
    favorites: 520000,
    tags: ['校园', '青春', '友情', '初恋'],
    totalChapters: 56,
    latestChapter: '第56话 - 毕业（完结）',
    updatedAt: '2026-06-30',
    chapters: [
      { number: 1, title: '新学期', updatedAt: '2025-10-01', images: [COMIC_IMG_F1, COMIC_IMG_F2, COMIC_IMG_F3, COMIC_IMG_A1] },
      { number: 2, title: '转校生', updatedAt: '2025-10-08', images: [COMIC_IMG_F2, COMIC_IMG_B2, COMIC_IMG_C1, COMIC_IMG_D3] },
      { number: 3, title: '同桌的你', updatedAt: '2025-10-15', images: [COMIC_IMG_F3, COMIC_IMG_A2, COMIC_IMG_B1, COMIC_IMG_C3] },
    ],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'dragon-king-reborn',
    title: '龙王重生',
    altTitle: 'Dragon King Reborn',
    author: '宋仲基',
    artist: '金裕贞',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%20featuring%20dragon%20king%20character%20with%20scales%20and%20horns%20in%20human%20form%2C%20epic%20fantasy%20setting%20with%20ancient%20palace%2C%20golden%20and%20crimson%20color%20scheme%2C%20majestic%20atmosphere%2C%20vertical%20poster%20design&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '一代龙王陨落后重生为凡人少年，带着前世的记忆重新踏上修炼之路。这一世，他要弥补所有遗憾，守护心中所爱，再次登临巅峰！',
    status: '连载中',
    rating: 4.8,
    views: 14500000,
    favorites: 950000,
    tags: ['重生', '玄幻', '逆袭', '热血'],
    totalChapters: 156,
    latestChapter: '第156话 - 龙啸九天',
    updatedAt: '2026-08-04',
    chapters: [
      { number: 1, title: '陨落', updatedAt: '2025-01-10', images: [COMIC_IMG_A1, COMIC_IMG_B1, COMIC_IMG_C1, COMIC_IMG_D1] },
      { number: 2, title: '重生', updatedAt: '2025-01-17', images: [COMIC_IMG_B2, COMIC_IMG_C2, COMIC_IMG_A2, COMIC_IMG_E1] },
      { number: 3, title: '新的开始', updatedAt: '2025-01-24', images: [COMIC_IMG_C3, COMIC_IMG_A3, COMIC_IMG_B3, COMIC_IMG_F1] },
    ],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'chef-miracle',
    title: '厨神传奇',
    altTitle: 'Chef Miracle',
    author: '韩佳人',
    artist: '赵寅成',
    category: '搞笑',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%20featuring%20cheerful%20chef%20character%20in%20busy%20restaurant%20kitchen%2C%20exaggerated%20funny%20expressions%2C%20delicious%20food%20dishes%20floating%2C%20warm%20and%20vibrant%20colors%2C%20humorous%20atmosphere%2C%20vertical%20poster%20design&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '失业青年李浩意外获得了传说中的厨神系统，从此他的料理人生发生了翻天覆地的变化。从路边摊到米其林，他用一道道美食征服了所有人的味蕾！',
    status: '连载中',
    rating: 4.4,
    views: 5800000,
    favorites: 420000,
    tags: ['美食', '搞笑', '系统', '励志'],
    totalChapters: 110,
    latestChapter: '第110话 - 终极料理',
    updatedAt: '2026-08-03',
    chapters: [
      { number: 1, title: '失业的第一天', updatedAt: '2025-04-01', images: [COMIC_IMG_D1, COMIC_IMG_E1, COMIC_IMG_F1, COMIC_IMG_A2] },
      { number: 2, title: '厨神系统觉醒', updatedAt: '2025-04-08', images: [COMIC_IMG_E2, COMIC_IMG_B1, COMIC_IMG_C3, COMIC_IMG_D2] },
      { number: 3, title: '第一道菜', updatedAt: '2025-04-15', images: [COMIC_IMG_F2, COMIC_IMG_A1, COMIC_IMG_B3, COMIC_IMG_E3] },
    ],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    slug: 'ancient-love-poem',
    title: '古诗中的爱情',
    altTitle: 'Ancient Love Poem',
    author: '金喜爱',
    artist: '李政宰',
    category: '古风',
    categorySlug: 'historical',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20cover%20art%20featuring%20ancient%20Korean%20noble%20couple%20in%20traditional%20silk%20clothing%2C%20moonlit%20garden%20setting%2C%20elegant%20and%20poetic%20atmosphere%2C%20soft%20ink%20wash%20painting%20style%2C%20romantic%20classical%20aesthetic%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '在古代朝鲜，一位才华横溢的书生与贵族小姐之间，因一首诗而展开的动人爱情故事。在那个等级森严的时代，他们能否冲破世俗的枷锁，携手共度余生？',
    status: '已完结',
    rating: 4.6,
    views: 5100000,
    favorites: 380000,
    tags: ['古风', '爱情', '文艺', '历史'],
    totalChapters: 48,
    latestChapter: '第48话 - 终成眷属（完结）',
    updatedAt: '2026-05-20',
    chapters: [
      { number: 1, title: '春日的邂逅', updatedAt: '2025-11-01', images: [COMIC_IMG_A1, COMIC_IMG_C2, COMIC_IMG_E1, COMIC_IMG_F3] },
      { number: 2, title: '一首诗', updatedAt: '2025-11-08', images: [COMIC_IMG_B2, COMIC_IMG_D1, COMIC_IMG_F1, COMIC_IMG_A3] },
      { number: 3, title: '夜会', updatedAt: '2025-11-15', images: [COMIC_IMG_C1, COMIC_IMG_E3, COMIC_IMG_B1, COMIC_IMG_D2] },
    ],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    slug: 'zombie-apocalypse-survival',
    title: '末日求生指南',
    altTitle: 'Zombie Apocalypse Survival',
    author: '黄政民',
    artist: '河正宇',
    category: '剧情',
    categorySlug: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%20featuring%20survivors%20in%20post%20apocalyptic%20city%2C%20tense%20and%20suspenseful%20atmosphere%2C%20ruined%20buildings%20background%2C%20characters%20showing%20determination%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20dark%20tones%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '一场突如其来的病毒席卷全球，城市变成了废墟。一群普通人在末日中挣扎求生，他们之间的信任、背叛、牺牲和救赎，构成了这部震撼人心的生存史诗。',
    status: '连载中',
    rating: 4.7,
    views: 9200000,
    favorites: 680000,
    tags: ['末日', '生存', '人性', '悬疑'],
    totalChapters: 88,
    latestChapter: '第88话 - 希望的曙光',
    updatedAt: '2026-08-02',
    chapters: [
      { number: 1, title: '爆发', updatedAt: '2025-05-15', images: [COMIC_IMG_E1, COMIC_IMG_B1, COMIC_IMG_D3, COMIC_IMG_A1] },
      { number: 2, title: '逃亡', updatedAt: '2025-05-22', images: [COMIC_IMG_F1, COMIC_IMG_C2, COMIC_IMG_E2, COMIC_IMG_B3] },
      { number: 3, title: '幸存者聚集', updatedAt: '2025-05-29', images: [COMIC_IMG_D1, COMIC_IMG_A2, COMIC_IMG_E3, COMIC_IMG_F2] },
    ],
    isHot: true,
    isNew: true,
    isRecommended: false,
  },
  {
    slug: 'healing-diary',
    title: '治愈日记',
    altTitle: 'Healing Diary',
    author: '裴秀智',
    artist: '南柱赫',
    category: '日常',
    categorySlug: 'daily',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%20featuring%20young%20woman%20in%20cozy%20cafe%20writing%20in%20journal%2C%20warm%20sunlight%20through%20window%2C%20plants%20and%20books%2C%20peaceful%20and%20healing%20atmosphere%2C%20soft%20pastel%20colors%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '都市女孩小鹿的日常生活记录。一杯咖啡、一本书、一只猫，简单却充满幸福感的每个瞬间。这是一部能治愈你心灵的作品，让你在喧嚣中找到内心的平静。',
    status: '连载中',
    rating: 4.5,
    views: 3800000,
    favorites: 290000,
    tags: ['日常', '治愈', '温暖', '生活'],
    totalChapters: 45,
    latestChapter: '第45话 - 雨天的幸福',
    updatedAt: '2026-08-04',
    chapters: [
      { number: 1, title: '一个人的早晨', updatedAt: '2026-01-10', images: [COMIC_IMG_F1, COMIC_IMG_D2, COMIC_IMG_A1, COMIC_IMG_C3] },
      { number: 2, title: '咖啡馆的午后', updatedAt: '2026-01-17', images: [COMIC_IMG_F2, COMIC_IMG_E1, COMIC_IMG_B2, COMIC_IMG_D1] },
      { number: 3, title: '遇见一只猫', updatedAt: '2026-01-24', images: [COMIC_IMG_F3, COMIC_IMG_A3, COMIC_IMG_C1, COMIC_IMG_E2] },
    ],
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    slug: 'shadow-hunter',
    title: '暗影猎手',
    altTitle: 'Shadow Hunter',
    author: '金南佶',
    artist: '李东旭',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%20featuring%20mysterious%20hunter%20with%20dual%20blades%20in%20dark%20city%20alley%2C%20dynamic%20action%20pose%2C%20shadow%20effects%2C%20intense%20atmosphere%2C%20neon%20accent%20lights%2C%20professional%20comic%20style%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '在这个世界阴暗的角落里，存在着一种名为暗影的神秘生物。猎手们世代守护着人类与暗影之间的平衡。新一代猎手的传奇故事，即将揭开序幕。',
    status: '连载中',
    rating: 4.6,
    views: 8200000,
    favorites: 610000,
    tags: ['动作', '奇幻', '都市', '热血'],
    totalChapters: 68,
    latestChapter: '第68话 - 暗影之王',
    updatedAt: '2026-08-03',
    chapters: [
      { number: 1, title: '觉醒', updatedAt: '2026-02-20', images: [COMIC_IMG_E1, COMIC_IMG_A2, COMIC_IMG_B3, COMIC_IMG_C1] },
      { number: 2, title: '第一次猎杀', updatedAt: '2026-02-27', images: [COMIC_IMG_B1, COMIC_IMG_E2, COMIC_IMG_D2, COMIC_IMG_F3] },
      { number: 3, title: '猎人学院', updatedAt: '2026-03-06', images: [COMIC_IMG_C2, COMIC_IMG_A1, COMIC_IMG_E3, COMIC_IMG_D1] },
    ],
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
];

export const faqs: FAQ[] = [
  {
    question: '韩漫在线是什么？',
    answer: '韩漫在线是一个专注于韩国漫画的免费在线阅读平台，我们收录了大量优质的韩漫作品，涵盖恋爱、奇幻、动作、搞笑等多种类型，支持全集下拉式阅读，让您随时随地畅享韩漫的乐趣。',
  },
  {
    question: '韩漫在线的漫画是免费的吗？',
    answer: '是的，韩漫在线上所有的漫画作品均免费提供阅读。我们致力于为广大漫画爱好者提供优质的阅读体验，无需付费即可畅享海量韩漫资源。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是一种专为手机和电脑优化的漫画阅读模式。您只需向下滑动页面，漫画就会以垂直滚动的方式连续呈现，无需翻页点击，阅读体验更加流畅自然，非常适合在手机上阅读长篇漫画。',
  },
  {
    question: '如何查找想看的漫画？',
    answer: '您可以通过以下几种方式查找漫画：1) 在首页浏览热门推荐和最新更新；2) 使用顶部的分类导航按类型筛选漫画；3) 在搜索框中输入漫画名称或作者进行搜索。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '不同漫画的更新频率有所不同。正在连载中的热门漫画通常每周更新一话，具体更新时间请关注每部漫画详情页的更新信息。我们会在第一时间同步最新内容。',
  },
  {
    question: '如何收藏喜欢的漫画？',
    answer: '在漫画详情页，您可以点击收藏按钮将喜欢的漫画加入收藏夹。收藏后，您可以在个人中心查看所有已收藏的漫画，方便随时继续阅读。',
  },
  {
    question: '韩漫在线支持哪些设备阅读？',
    answer: '韩漫在线完美适配电脑、平板和手机等多种设备。无论您使用什么设备，都能获得优秀的阅读体验。推荐使用手机竖屏阅读，配合下拉式阅读模式效果最佳。',
  },
];

export const reviews: Review[] = [
  {
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20avatar%2C%20soft%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '韩漫在线真的是我的宝藏网站！更新速度快，画质清晰，下拉式阅读体验太舒服了。强烈推荐给所有喜欢韩漫的朋友！',
    date: '2026-07-28',
  },
  {
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20avatar%2C%20friendly%20expression%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '没想到有专门做韩漫的网站，分类很详细，想看的漫画基本都能找到。而且全部免费，真的太良心了！',
    date: '2026-07-25',
  },
  {
    name: '小张',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20avatar%2C%20bright%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '下拉式阅读模式真的太好用了，比传统翻页方便太多。每天通勤路上看几话韩漫已经成为我的日常习惯。',
    date: '2026-07-20',
  },
  {
    name: '小刘',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20avatar%2C%20casual%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '漫画资源很丰富，界面也很简洁好看。希望以后能增加更多完结的漫画作品，有些追更中的等得太着急了哈哈。',
    date: '2026-07-15',
  },
];

export const siteInfo = {
  name: '韩漫在线',
  tagline: '免费韩国漫画大全 - 全集下拉式阅读',
  description: '韩漫在线是国内领先的韩国漫画免费阅读平台，致力于为广大漫画爱好者提供优质、便捷、免费的韩漫阅读体验。我们收录了超过数千部各类韩漫作品，涵盖恋爱、奇幻、动作、搞笑、悬疑、校园、古风等多种类型，支持创新的下拉式阅读模式。无论您喜欢什么类型的韩漫，都能在这里找到心仪的作品。',
  founded: '2024年',
  email: 'contact@hanmanonline.com',
  qq: '1234567890',
  wechat: 'HanManOnline',
  totalComics: 5000,
  totalUsers: 2000000,
  totalViews: 150000000,
  features: [
    { title: '海量资源', description: '收录数千部精品韩漫，涵盖各种类型，持续更新中', icon: 'ri-database-2-line' },
    { title: '完全免费', description: '所有漫画免费阅读，无需付费，畅享无限阅读乐趣', icon: 'ri-vip-crown-line' },
    { title: '下拉式阅读', description: '创新的垂直滚动阅读模式，流畅自然，告别翻页', icon: 'ri-arrow-down-line' },
    { title: '高清画质', description: '提供高清漫画图片，完美呈现每一处细节', icon: 'ri-image-line' },
    { title: '多端适配', description: '完美适配电脑、平板和手机，随时随地畅读韩漫', icon: 'ri-device-line' },
    { title: '极速更新', description: '第一时间同步最新连载，追更不停歇', icon: 'ri-flashlight-line' },
  ],
};